import { Link } from "react-router-dom";
import { CheckCircle2, Circle, Gift, Crown, Plus } from "lucide-react";

/** Free → $100 plan → +$20 per extra Hosting, plus the two sell requirements. */
export function PlanLadder({ s }) {
  const free = s.starter_free_listings ?? 5;
  const addon = s.hosting_addon_usd ?? 20;
  const tiers = [
    { icon: Gift, name: "Free", price: "$0", accent: "text-neutral-300", items: [
      "Sign up with your email", `Show your first ${free} products (feed + Stage)`, "One Hosting of your choice — everything inside it free", "Your first live session", "Buyers can message / enquire",
    ] },
    { icon: Crown, name: "Seller plan", price: `$${Math.round(s.monthly_fee_usd)}/mo · $${Math.round(s.annual_fee_usd)}/yr`, accent: "text-[#FF3B30]", items: [
      "Buy now switches on (with verified ID)", "Keep 99.5% of every sale — 0.5% fee per item", "Unlimited products", "Unlimited live sessions", "3 free Max boosts every month", "AI listing tools",
    ] },
    { icon: Plus, name: "Extra Hostings", price: `+$${Math.round(addon)}/mo each`, accent: "text-[#FF9F0A]", items: [
      "Add Games, Theatre, Events, Sports, Gallery…", "All roles & formats inside each Hosting", "Billed per Hosting for 30 days", "On top of the seller plan",
    ] },
  ];
  const reqs = [
    { done: s.is_active, label: "Active seller plan" },
    { done: s.kyc_status === "verified", label: s.kyc_status === "pending" ? "ID verification (under review)" : "Verified ID", href: "/payouts" },
  ];

  return (
    <div data-testid="plan-ladder" className="mt-6 space-y-4">
      <div className="grid md:grid-cols-3 gap-3">
        {tiers.map((t, i) => (
          <div key={t.name} data-testid={`plan-tier-${i}`} className="rounded-xl border border-[#27272A] bg-[#121212] p-5">
            <div className={`flex items-center gap-2 text-xs uppercase tracking-widest ${t.accent}`}><t.icon className="h-4 w-4" /> {t.name}</div>
            <div className="mt-2 font-mono font-bold text-lg text-white">{t.price}</div>
            <ul className="mt-3 space-y-1.5 text-sm text-neutral-300">
              {t.items.map((x) => <li key={x} className="flex items-start gap-2"><CheckCircle2 className="h-3.5 w-3.5 mt-1 text-[#34C759] shrink-0" /> {x}</li>)}
            </ul>
          </div>
        ))}
      </div>
      {s.role === "seller" && (
        <div data-testid="sell-requirements" className={`rounded-xl border p-5 ${s.can_sell ? "border-[#34C759]/40 bg-[#34C759]/[0.05]" : "border-[#27272A] bg-[#121212]"}`}>
          <div className="text-xs uppercase tracking-widest text-neutral-500">To take payments (Buy now)</div>
          <div className="mt-2 font-bold text-white">{s.can_sell ? "You're cleared to sell." : "Both steps are needed before buyers can pay you."}</div>
          <ul className="mt-3 space-y-2 text-sm">
            {reqs.map((r) => (
              <li key={r.label} className="flex items-center justify-between gap-3">
                <span className="flex items-center gap-2">{r.done ? <CheckCircle2 className="h-4 w-4 text-[#34C759]" /> : <Circle className="h-4 w-4 text-neutral-600" />}<span className={r.done ? "text-neutral-400" : "text-neutral-200"}>{r.label}</span></span>
                {!r.done && r.href && <Link to={r.href} className="text-xs font-bold text-[#FF9F0A] hover:underline" data-testid="verify-id-link">Upload ID →</Link>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
